import Vuex from 'vuex';
import SessionStore from './modules/sessions';


export default class Store {


  constructor(Vue, {storeModules}) {
    Vue.use(Vuex);

    const store = new Vuex.Store({
      state: {
        loading: false,
        referrer: {
          type: 'direct',
          data: {}
        },
        invitationId: ''
      },


      mutations: {
        /**
         * set loading status & activate the loading overlay
         *
         * @param {Object} state
         * @param {status} status loading status
         */
        setLoading(state, status) {
          state.loading = status;
        },


        /**
         * set new invitation id in state
         *
         * @param {Object} state
         * @param {string} id of invitation
         */
        setInvitationId(state, id) {
          state.invitationId = id;
        },


        /**
         * set referrer type
         *
         * @param {Object} state
         * @param {Object} referrer
         */
        setReferrer(state, referrer) {
          if (typeof referrer !== 'object') {
            throw new TypeError('Typeof referrer have to be "Object"');
          }

          const allowedKeys = ['type', 'data'];
          const referrerTypes = ['direct', 'invitation'];

          const keys = Object.keys(referrer);

          for (let i = 0; i < keys.length; i++) {
            if (allowedKeys.indexOf(keys[i]) === -1) {
              throw new TypeError('Unexepted object key');
            }
          }

          if (!referrer.type || referrerTypes.indexOf(referrer.type) === -1) {
            throw new TypeError('Unexepted referrer type');
          }

          state.referrer = referrer;
        }
      },


      actions: {
        /**
         * @param {Function} commit
         * @param {Boolean} status
         */
        loading({commit}, status) {
          commit('setLoading', status);
        },


        /**
         * init invitation by id
         *
         * @param {Function} commit
         * @param {string} id of invitation
         */
        invitation({commit}, id) {
          commit('setInvitationId', id);
        },


        /**
         * trigger function to set new referrer
         *
         * @param {Function} commit
         * @param {Object} referrer
         */
        setReferrer({commit}, referrer) {
          commit('setReferrer', referrer);
        }
      },


      getters: {
        loading(state) {
          return state.loading;
        },

        referrer(state) {
          return state.referrer;
        },

        invitationId(state) {
          return state.invitationId;
        }
      },


      modules: {
        ...storeModules,
        session: SessionStore
      }
    });

    Vue.store = store;

    return store;
  }
}
